import React from 'react';

import { Tooltip } from '@poseidon/components/Tooltip';
import { type SvrListTeam } from '@poseidon/types/svr/svrTeam.type';

import { Avatar, TeamUserAvatar } from '@/components/Avatar';

interface UserIconsProps {
  listTeam: SvrListTeam;
}

export default function UserIcons({ listTeam }: UserIconsProps) {
  const remainingLength = listTeam.userCounts - listTeam.nUserImages.length;
  return (
    <div className="flex justify-end">
      {listTeam.nUserImages.map((userImage, i) => (
        <Tooltip label={userImage?.name ?? userImage.email} key={i}>
          <TeamUserAvatar
            className="-ml-1 size-6 ring-2 ring-white dark:ring-slate-800"
            teamUser={{
              userTeamName: userImage.name || undefined,
              profilePicture: userImage.profilePicture || undefined,
              userEmail: userImage.email,
            }}
            shape="circle"
          />
        </Tooltip>
      ))}
      {remainingLength > 0 && (
        <Avatar
          srcs={[]}
          alt={`+ ${remainingLength}`}
          className="-ml-1 size-6 ring-2 ring-white dark:ring-slate-800"
          coloredBackground
          shape="circle"
        />
      )}
    </div>
  );
}
